import React, {useEffect, useRef, useState} from 'react';
import {getOtherUserDuoConversation} from "./utils";
import styled from "styled-components";
import {useChatTrackedState} from "./store";

export const ContainerDot = styled.div`
    position: relative;
    width: 14px;
    height: 14px;
    align-self: center;
    background-color: ${props => (props.status === "Offline" ? "rgb(124, 152, 182)" : "rgb(0, 189, 165)")};
    border-radius: 50%;
    border: 2px solid white;
    top: 10px;
    left: -10px;
    min-width: 14px;
`;


type Props = {
    conversation: any;
    type?: string;
};

const OnlineIndicator: React.FC<Props> = ({conversation}) => {
    const {conversationClient} = useChatTrackedState();
    const [otherUser, setOtherUser] = useState({loading: false, status: "Offline", user: null});
    const {status} = otherUser;
    const userRef = useRef<any | null>(null);

    useEffect(() => {
        const abortController = new AbortController();
        if (conversation && conversationClient) {
            getOtherUserDuoConversation(conversation).then(user => {
                if (user) {
                    if (user.isOnline) {
                        // @ts-ignore
                        setOtherUser({loading: false, status: 'Online', user: user});
                    } else if (!user.isOnline) {
                        // @ts-ignore
                        setOtherUser({loading: false, status: 'Offline', user: user});
                    }
                    // @ts-ignore
                    userRef.current = user;
                }
            });
        }
        return () => {
            if (conversation) {
                conversation.removeAllListeners();
            }
            abortController.abort();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        try {
            // @ts-ignore
            // if (otherUser.user.friendlyName === '') {
            //     console.log({otherUser, userRef});
            // }
            if (conversation.sid === 'CH50850ac98f6e4292afecf85098b9733f' || conversation.sid === 'CHf7fae553131a45e5b042050b418e3192' || conversation.sid === 'CHa387015835524690bc78002a06ee7841') {
                console.log({
                    conversation,
                    user: userRef.current,
                });
            }
            if (userRef.current) {
                // @ts-ignore
                // userRef.current.on('userSubscribed', (event) => {
                //     if (conversation.sid === 'CH50850ac98f6e4292afecf85098b9733f' || conversation.sid === 'CHf7fae553131a45e5b042050b418e3192' || conversation.sid === 'CHa387015835524690bc78002a06ee7841') {
                //         console.log({userSubscribed: event});
                //     }
                // });
                // userRef.current.on('userUnsubscribed', (event) => {
                //     if (conversation.sid === 'CH50850ac98f6e4292afecf85098b9733f' || conversation.sid === 'CHf7fae553131a45e5b042050b418e3192' || conversation.sid === 'CHa387015835524690bc78002a06ee7841') {
                //         console.log({userUnsubscribed: event});
                //     }
                // });
                // @ts-ignore
                userRef.current.on('updated', (event) => {
                    // if (conversation.sid === 'CH50850ac98f6e4292afecf85098b9733f' || conversation.sid === 'CHf7fae553131a45e5b042050b418e3192' || conversation.sid === 'CHa387015835524690bc78002a06ee7841') {
                    //     console.log({updated: event});
                    // }
                    if (event.user) {
                        // @ts-ignore
                        if (event.user.isOnline) {
                            setOtherUser((prevState) => ({
                                ...prevState,
                                status: 'Online',
                            }));
                        } else {
                            setOtherUser((prevState) => ({
                                ...prevState,
                                status: 'Offline',
                            }));
                        }
                    }
                });
            }
        } catch (e) {
            console.error({user_updated: e});
        }
        return () => {
            try {

                if (userRef.current) {
                    // @ts-ignore
                    userRef.current.removeListener('updated', () => {
                    });
                }
            } catch (e) {
                console.error({user_updated_return: e});
            }
        };
    }, [otherUser.user]);

    return (
        <ContainerDot status={status}/>
    );
}

function propsAreEqual(prev, next) {
    return prev.conversation.sid === next.conversation.sid;
}

const MemoizedOnlineIndicator = React.memo(OnlineIndicator, propsAreEqual);
// export default OnlineIndicator;
export default MemoizedOnlineIndicator;